/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ls_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online line sorter. Sort a list of lines alphabetically, numerically, or by length, with reverse and case-insensitive options. Works in your browser.`)
};

const es_ls_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenador de líneas gratuito en línea. Ordena una lista de líneas alfabética, numérica o por longitud, con opciones de inversión e insensibilidad a mayúsculas. Funciona en tu navegador.`)
};

const de_ls_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Zeilensortierer. Sortieren Sie eine Liste von Zeilen alphabetisch, numerisch oder nach Länge, mit Optionen zum Umkehren und zur Ignorierung der Groß-/Kleinschreibung. Funktioniert in Ihrem Browser.`)
};

const nl_ls_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online regelsorteerprogramma. Sorteer een lijst met regels alfabetisch, numeriek of op lengte, met omgekeerde en niet-hoofdlettergevoelige opties. Werkt in uw browser.`)
};

const fr_ls_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trieur de lignes en ligne gratuit. Triez une liste de lignes alphabétiquement, numériquement ou par longueur, avec des options d'inversion et insensible à la casse. Fonctionne dans votre navigateur.`)
};

const it_ls_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordinatore di linee online gratuito. Ordina un elenco di righe alfabeticamente, numericamente o per lunghezza, con opzioni di inversione e senza distinzione tra maiuscole e minuscole. Funziona nel tuo browser.`)
};

const pt_br2_ls_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenador de linhas online gratuito. Ordene uma lista de linhas alfabética, numérica ou por comprimento, com opções de reversão e sem distinção de maiúsculas. Funciona no seu navegador.`)
};

const pt_ls_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificador de linhas online gratuito. Classifique uma lista de linhas alfabeticamente, numericamente, ou por comprimento, com opções de inversão e insensibilidade a maiúsculas/minúsculas. Funciona no seu navegador.`)
};

const ja_ls_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料オンライン行ソーター。行のリストをアルファベット順、数値順、または長さでソート。逆順と大文字小文字区別なしオプション付き。ブラウザで実行できます。`)
};

const zh_ls_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的在线行排序工具。按字母顺序、数字顺序或行长度对列表中的行排序，支持反向排序和不区分大小写选项。在你的浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ls_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ls_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ls_meta_description", locale)
	if (locale === "en") return en_ls_meta_description(inputs)
	if (locale === "es") return es_ls_meta_description(inputs)
	if (locale === "de") return de_ls_meta_description(inputs)
	if (locale === "nl") return nl_ls_meta_description(inputs)
	if (locale === "fr") return fr_ls_meta_description(inputs)
	if (locale === "it") return it_ls_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_ls_meta_description(inputs)
	if (locale === "pt") return pt_ls_meta_description(inputs)
	if (locale === "ja") return ja_ls_meta_description(inputs)
	return zh_ls_meta_description(inputs)
};